export default "<div class=\"chart-container\">\r\n    <canvas id=\"chartLine{{idCanvas}}\" >{{ chart }}</canvas>\r\n</div>\r\n"